import { render, staticRenderFns } from "./notesToTheConsolidatedFinancialStatements.vue?vue&type=template&id=563a21f6&"
import script from "./notesToTheConsolidatedFinancialStatements.vue?vue&type=script&lang=js&"
export * from "./notesToTheConsolidatedFinancialStatements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports